const PRODUCT_PLACEHOLDER_IMAGE = "/assets/graphics/img-product.svg";

// <img @error> handler: show the default product image when the image URL fails to load
function showPlaceholderImage(event) {
    const image = event?.target;
    if (image && !image.src.endsWith(PRODUCT_PLACEHOLDER_IMAGE)) {
        image.src = PRODUCT_PLACEHOLDER_IMAGE;
    }
}

module.exports = { PRODUCT_PLACEHOLDER_IMAGE, showPlaceholderImage };
